// import React from 'react'
import "./ThirdSection.scss";
import cartIcon from "../../../../../Assets/Images/icon/cart-icon.png";
import arrowRight from "../../../../../Assets/Images/icon/arrow-right.png";
import arrowRightBlack from "../../../../../Assets/Images/icon/arrow-right-black.png";
import briefCase from "../../../../../Assets/Images/icon/brief-case.png";
import truckIcon from "../../../../../Assets/Images/icon/truck-icon.png";
import happyXrGuy from "../../../../../Assets/Images/happy-guy-xr.webp";
import testimonialImg1 from "../../../../../Assets/Images/testimonialImg1.png";
import earringGuy from "../../../../../Assets/Images/earring-guy.png";
import checked from "../../../../../Assets/Images/icon/tick-circle-blue.png";
import trendsUp from "../../../../../Assets/Images/icon/trend-up-green.png";
import profilePurple from "../../../../../Assets/Images/icon/profile-2user-purple.png";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const testimonials = [
  {
    name: "Bee Banks",
    title: "Estate Developer, Lagos Nigeria",
    img: testimonialImg1,
    text: "",
  },
  {
    name: "John Scott",
    title: "Home Owner, Lagos Nigeria",
    img: earringGuy,
    text: `Thousands of buyers, builders, and developers already use CinderBuild to source materials, explore properties, and manage projects. Don't be left out, create your account in minutes.`,
  },
  {
    name: "Samuel Banks",
    title: "Estate Developer, Lagos Nigeria",
    img: testimonialImg1,
    text: "",
  },
  // {
  //   name: 'Jane Doe',
  //   title: 'Architect, Abuja',
  //   img: earringGuy,
  //   text: 'Kee has made sourcing building materials faster and simpler for my projects.',
  // },
  // {
  //   name: 'Michael Lee',
  //   title: 'Contractor, Port Harcourt',
  //   img: testimonialImg1,
  //   text: '',
  // },
];

const ThirdSection = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 60 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <section>
      <div className="whoWeServe">
        <button className="btn">
          {/* <a className="" href="/"> */}
          Who we serve
          {/* </a> */}
        </button>
        <div className="built">
          <span>Built For Everyone </span> <span>in</span>
          <p>the Business of Building</p>
        </div>
        <p className="builtText">
          No matter your role in construction CinderBuild provides one platform
          that simplifies procurement, reduces cost, and ensures quality
          delivery.
        </p>
      </div>
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.5 }}
        className="accountType"
      >
        <motion.div className="singleBuyer" variants={item}>
          <div className="firstCon">
            <div className="cartIcon">
              <img src={cartIcon} alt="cart" />
            </div>
            <button className="btn btn-light">Personal</button>
          </div>
          <h3>Individual Buyer</h3>
          <p>Perfect for small contractors and individual builders</p>
          <ul>
            <li>Small quantity purchases</li>
            <li>Quick ordering</li>
            <li>Quick ordering</li>
            <li>Basic dashboard</li>
          </ul>
          <Link
            to="/register"
            onClick={() => window.scrollTo(0, 0)}
            className="arrowRight btn"
          >
            <img src={arrowRight} alt="" />
          </Link>
        </motion.div>
        <motion.div className="corporateBuyer" variants={item}>
          <div className="firstCon">
            <div className="cartIcon">
              <img src={briefCase} alt="brief case" />
            </div>
            <button className="btn btn-light">Business</button>
          </div>
          <h3 className="heading">Corporate Buyer</h3>
          <p>Designed for large construction companies and bulk purchasers</p>
          <ul>
            <li>Bulk purchasing discount</li>
            <li>Advanced analytics</li>
            <li>Priority support</li>
            <li> Custom pricing</li>
          </ul>
          <Link to="/enterprise-setup" className="arrowRight btn">
            <img src={arrowRightBlack} alt="" />
          </Link>
        </motion.div>
        <motion.div className="vendor" variants={item}>
          <div className="firstCon">
            <div className="cartIcon">
              <img src={truckIcon} alt="brief case" />
            </div>
            <button className="btn btn-light">Vendor</button>
          </div>
          <h3 className="heading">Supplier</h3>
          <p>Perfect for small contractors and individual builders</p>
          <ul>
            <li>Small quantity purchases</li>
            <li>Quick ordering</li>
            <li>Standard pricing</li>
            <li> Basic dashboard</li>
          </ul>
          <Link
            to="/register"
            onClick={() => window.scrollTo(0, 0)}
            className="arrowRight btn"
          >
            <img src={arrowRight} alt="" />
          </Link>
        </motion.div>
      </motion.div>
      <div className="finance">
        <motion.div
          className="firstCon"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false }}
        >
          <button className="btn btn-light financeBtn">
            Financing Solutions
          </button>
          <h3 className="withEase">
            Finance Your Next Project{" "}
            <span className="highlight">with Ease</span>
          </h3>
          <p>
            At CinderBuild, we understand that great projects often need more
            than just materials or land — they need the right financial support.
            That&apos;s why we offer flexible financing options for both our
            building materials marketplace and our real estate platform. Whether
            you&apos;re a corporate buyer sourcing bulk materials, an individual
            building your dream home, or a developer working on large-scale
            projects, we make financing simple, transparent, and accessible.
          </p>
          <button className="btn heroBtn heroBtn-filled d-none d-md-block">
            Learn more →
          </button>
        </motion.div>
        <motion.div
          className="personImg"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: false, amount: 0.5 }}
          animate={{ y: [0, -6, 0] }}
          // transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
        >
          <img src={happyXrGuy} alt="person" />
        </motion.div>
        <button className="btn heroBtn heroBtn-filled d-md-none">
          Learn more →
        </button>
      </div>
      <div className="testimonial">
        <div className="firstCon">
          <button className="btn">
            {/* <a className="" href="/"> */}
            Testimonials
            {/* </a> */}
          </button>{" "}
          <div className="why">
            <h3>Why Our Customers</h3>
            <h3>Trust CinderBuild</h3>
            <p>
              See how builders, suppliers, and property owners rely on us to
              deliver quality and convenience every time.
            </p>
          </div>
        </div>
        <div className="secondCon">
          <Swiper
            direction="vertical"
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            speed={800}
            loop={true}
            // autoHeight={true}
            slidesPerView={3}
            spaceBetween={32}
            // breakpoints={{
            //   0: { slidesPerView: 1.2, spaceBetween: 16 },
            //   480: { slidesPerView: 2, spaceBetween: 20 },
            //   768: { slidesPerView: 2.5, spaceBetween: 24 },
            //   1024: { slidesPerView: 3, spaceBetween: 32 },
            // }}
            modules={[Autoplay]}
            className="testimonialSwiper"
          >
            {testimonials.map((t, i) => (
              <SwiperSlide key={i}>
                <div
                  className={`testimonialCard ${
                    t.name === "John Scott" ? "scott" : t.text ? "withText" : ""
                  }`}
                >
                  <div className="innerWrapper">
                    <div className="imgName">
                      <div>
                        <img src={t.img} alt={t.name} />
                      </div>
                      <div className="comment">
                        <h3>{t.name}</h3>
                        <p>{t.title}</p>
                      </div>
                    </div>
                    {t.text && <p className="reliable">{t.text}</p>}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className="marketing container py-5">
        <div className="row row-cols-1 row-cols-md-3 g-4">
          <div className="col">
            <div className="card marketing-card h-100 text-center border-0 p-4">
              <div className="checkedIcon icon1">
                <img src={checked} alt="quality guaranteed" />
              </div>
              <div className="card-body">
                <h5 className="card-title">Quality Guaranteed</h5>
                <p className="card-text">
                  All our products undergo strict quality checks to ensure top
                  performance and reliability.
                </p>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card marketing-card h-100 text-center border-0 p-4">
              <div className="checkedIcon icon2">
                <img src={trendsUp} alt="verified supplier" />
              </div>
              <div className="card-body">
                <h5 className="card-title">Best Market Prices</h5>
                <p className="card-text">
                  Our direct relationships with manufacturers allow us to offer
                  competitive prices without compromising on quality.
                </p>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card marketing-card h-100 text-center border-0 p-4">
              <div className="checkedIcon icon3">
                <img src={profilePurple} alt="verified supplier" />
              </div>
              <div className="card-body">
                <h5 className="card-title">Expert Advice</h5>
                <p className="card-text">
                  Our team of construction experts is always available to help
                  you choose the right materials for your specific project
                  needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThirdSection;
